<!-- Container for sidebar(s) + page content -->

<div class="topnav">
  <a class="active" (click)="_toggleSidebar()" class="menu-button">
    <img src="../../../assets/Logo-new.svg" class="" style="height: 75px;">
  </a>
  <a style="float:right" class="logout-button" (click)="logout()"><img src="../../../assets/logout.png"
      style="width: 20px;  height: 20px;  margin-top: 8px;">
  </a>
  <a style="float:right ">
    <p style="color: #3C675F;
      margin-top: 1.2rem;
      padding-left: 15px;
      font-weight: 400;
      font-size: 14px;
      margin-bottom: 0;
      border-left: 1px solid #9BC4BC;"> {{username}}</p>
    <p style="color: #3C675F;
        margin-top: 0;
            padding-left: 15px;
        font-weight: 400;
        font-size: 14px;
        border-left: 1px solid #9BC4BC;">GOAW,&nbsp;{{location}}</p>
  </a>
</div>

<ng-sidebar-container style="height: 100vh;" id="loader">



  <!-- A sidebar -->
  <ng-sidebar [(opened)]="_opened" position="left" mode="{{slideType}}">
    <aside class="sidebar shadow-sm">
      <div class="sidebar-content">
        <nav class="sidebar-menu pt-3 pb-3">

          <ul class="menu-items" *ngIf="mobileDevice">
            <li *ngFor="let page of menuPages" class="mb-2" style="border-radius: 15px;">
              <a (click)="getClick(page)" [ngClass]="{'selected': page.isSelected, 'unselected': !page.isSelected}">
                <span class="float-left" style="color:#fff;cursor: pointer;font-size: 13px;">{{page.name}}</span>
                <span class="float-right">
                  <i class="fa fa-angle-down" style="font-size:1.5rem;color:#fff"></i>

                </span>
              </a>
              <ul *ngIf="page.isSelected && page.dropDown" class="pl-0 pt-2 child-li mt-2"
                style="padding-right: 0px !important;">
                <li style="padding: 10px;
                              cursor: pointer;
                                border-radius: 10px;
                                padding-bottom: 0;
                                background: #fff;
                                color: #3C675F;
                                padding-bottom: 10px;
                                margin-top: 1rem;">
                  <button *ngFor="let item of page.dropDown" (click)="changeBackground(item , page)"
                    [style.background]="item.isSelected ? '#dedede':'#fff'" [routerLink]="item.path"
                    routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" style="padding: 8px;
                    border: none;
                    font-weight: 500;
                    font-size: 22px;
                    /* line-height: 26px; */
                    color: #3C675F;
                    font-weight: bold;
                    width: 100%;
                    font-size: 12px;
                    text-align: left;
                    cursor: pointer;
                    border-radius: 5px;
                    background: rgb(222, 222, 222);">{{item.name}}</button>


                </li>
              </ul>

            </li>


          </ul>

          <ul class="menu-items pl-0 p-0" *ngIf="!mobileDevice">
            <li *ngFor="let page of menuPages" class="mb-2" style="border-radius: 15px;">
 
              <a (click)="getClick(page)" [ngClass]="{'selected': page.isSelected, 'unselected': !page.isSelected}">
                <span class="float-left" style="color:#fff;cursor: pointer;font-size: 13px;">{{page.name}}</span>
                <span class="float-right">
                  <i class="fa fa-angle-down" style="font-size:1.5rem;color:#fff"></i>

                </span>
              </a>
              <ul *ngIf="page.isSelected && page.dropDown" class="pl-0 pt-2 child-li mt-2"
                style="padding-right: 0px !important;">
                <li style="padding: 10px;
                              cursor: pointer;
                                border-radius: 10px;
                                padding-bottom: 0;
                                background: #fff;
                                color: #3C675F;
                                padding-bottom: 10px;
                                margin-top: 1rem;">
                  <button *ngFor="let item of page.dropDown" (click)="changeBackground(item , page)"
                    [style.background]="item.isSelected ? '#dedede':'#fff'" [routerLink]="item.path"
                    routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" style="padding: 8px;
                    border: none;
                    font-weight: 500;
                    font-size: 22px;
                    /* line-height: 26px; */
                    color: #3C675F;
                    font-weight: bold;
                    width: 100%;
                    font-size: 12px;
                    text-align: left;
                    cursor: pointer;
                    border-radius: 5px;
                    background: rgb(222, 222, 222);">{{item.name}}</button>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  </ng-sidebar>


  <!-- Page content -->
  <div ng-sidebar-content>



  


    <router-outlet></router-outlet>
    <footer >
      Copyright © Government Opium & Alkaloids Works | All Rights Reserved
    
    </footer>
  </div>

</ng-sidebar-container>
